import type { ReactNode } from "react";
import type { Control, FieldErrors } from "react-hook-form";
import { ProjectDetailsSection } from "components/common/CreateProjectSheet/components/ProjectDetailsSection";
import { FeaturesSection } from "components/common/CreateProjectSheet/components/FeaturesSection";
import type { FormData } from "components/common/CreateProjectSheet/CreateProjectSheet.types";

export type DetailsStageProps = {
  control: Control<FormData>;
  errors: FieldErrors<FormData>;
  mode: "project" | "version";
  layout: "minimal" | "full";
  /** Rendered after project details and before features (e.g. screenplay import). */
  afterDetails?: ReactNode;
  /** Pass-through to {@link FeaturesSection}. */
  otpDraftWithoutAvailableLicense?: boolean;
  /** Pass-through to {@link FeaturesSection}. */
  finalDraftTagCount?: number;
};

export const DetailsStage = ({
  control,
  errors,
  mode,
  layout,
  afterDetails,
  otpDraftWithoutAvailableLicense,
  finalDraftTagCount,
}: DetailsStageProps) => (
  <div className={layout === "minimal" ? "flex flex-col gap-4" : "flex flex-col gap-8"}>
    <ProjectDetailsSection
      control={control}
      errors={errors}
      mode={mode}
      variant={layout === "minimal" ? "nameOnly" : "full"}
    />
    {afterDetails}
    {layout === "full" ? (
      <FeaturesSection
        otpDraftWithoutAvailableLicense={otpDraftWithoutAvailableLicense}
        finalDraftTagCount={finalDraftTagCount}
      />
    ) : null}
  </div>
);
